// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxbtc } from "../../../icons/mono/build/icon-axbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxbtcIcon.displayName = 'AxbtcIcon';
}

export default AxbtcIcon;